module.exports = __webpack_public_path__ + "img/songdoconvensia-app.f0661c38.png";